import { render, staticRenderFns } from "./company-dynamics.vue?vue&type=template&id=871fd25a&scoped=true&"
import script from "./company-dynamics.vue?vue&type=script&lang=js&"
export * from "./company-dynamics.vue?vue&type=script&lang=js&"
import style0 from "./company-dynamics.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./company-dynamics.vue?vue&type=style&index=1&id=871fd25a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fd25a",
  null
  
)

export default component.exports